<template>
  <div class="modal" tabindex="-1" role="dialog" style="display:block!important" v-if="show_modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Anweisungen
          </h5>
        </div>
        <div class="modal-body">
          <p>Du hast <b>{{instructions.full_name}}</b> in Empfang genommen!</p>
          <p>Bitte Händige ein <b>{{instructions.badge}}</b> Pass aus.</p>
          <p v-if="instructions.shirt"><b>Außerdem bekommt {{instructions.full_name}} noch ein Crewshirt in der Größe {{ $filters.shirtSizeName(instructions.shirt) }}</b></p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success" @click="_confirm()">Fertig!</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop" v-if="show_modal"></div>
</template>

<script>
export default {
  name: "ReceptionModal",
  data() {
    return {
      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
      show_modal: false,
      instructions: {}
    }
  },
  methods: {
    show(instructions) {
      this.instructions = instructions;
      this.show_modal = true;

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.show_modal = false;
      this.resolvePromise()
    }
  }
}
</script>

<style scoped>

</style>